import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { $document } from '../document';
import { Event } from '../Event';
import { getCanvas } from '../register';

var PointerEvent = function (_Event) {
  _inherits(PointerEvent, _Event);

  var _super = _createSuper(PointerEvent);

  function PointerEvent(type) {
    var _this;

    _classCallCheck(this, PointerEvent);

    _this = _super.call(this, type);

    _defineProperty(_assertThisInitialized(_this), "buttons", void 0);

    _defineProperty(_assertThisInitialized(_this), "which", void 0);

    _defineProperty(_assertThisInitialized(_this), "pointerId", void 0);

    _defineProperty(_assertThisInitialized(_this), "bubbles", void 0);

    _defineProperty(_assertThisInitialized(_this), "button", void 0);

    _defineProperty(_assertThisInitialized(_this), "width", void 0);

    _defineProperty(_assertThisInitialized(_this), "height", void 0);

    _defineProperty(_assertThisInitialized(_this), "pressure", void 0);

    _defineProperty(_assertThisInitialized(_this), "isPrimary", void 0);

    _defineProperty(_assertThisInitialized(_this), "pointerType", void 0);

    _defineProperty(_assertThisInitialized(_this), "altKey", void 0);

    _defineProperty(_assertThisInitialized(_this), "ctrlKey", void 0);

    _defineProperty(_assertThisInitialized(_this), "metaKey", void 0);

    _defineProperty(_assertThisInitialized(_this), "shiftKey", void 0);

    _this.target = getCanvas();
    _this.currentTarget = getCanvas();
    return _this;
  }

  return PointerEvent;
}(Event);

var CLONE_PROPS = ['bubbles', 'cancelable', 'view', 'detail', 'screenX', 'screenY', 'clientX', 'clientY', 'ctrlKey', 'altKey', 'shiftKey', 'metaKey', 'button', 'relatedTarget', 'pointerId', 'width', 'height', 'pressure', 'tiltX', 'tiltY', 'pointerType', 'hwTimestamp', 'isPrimary', 'pageX', 'pageY', 'timeStamp'];
var CLONE_DEFAULTS = [false, false, null, null, 0, 0, 0, 0, false, false, false, false, 0, null, 0, 0, 0, 0, 0, 0, 0, '', 0, false, 0, 0, 0];
var POINTER_TYPE = 'touch';

function touchToPointer(type, touch, rawEvent) {
  var e = new PointerEvent(type);

  for (var i = 0; i < CLONE_PROPS.length; i++) {
    var p = CLONE_PROPS[i];
    e[p] = touch[p] || CLONE_DEFAULTS[i];
  }

  e.type = type;
  e.target = getCanvas();
  e.currentTarget = getCanvas();
  e.buttons = typeToButtons(type);
  e.which = e.buttons;
  e.pointerId = (touch.identifier || 0) + 2;
  e.bubbles = true;
  e.cancelable = true;
  e.button = 0;
  e.width = (touch.radiusX || 0.5) * 2;
  e.height = (touch.radiusY || 0.5) * 2;
  e.pressure = touch.force || 0.5;
  e.isPrimary = isPrimaryPointer(touch);
  e.pointerType = POINTER_TYPE;
  e.altKey = rawEvent.altKey;
  e.ctrlKey = rawEvent.ctrlKey;
  e.metaKey = rawEvent.metaKey;
  e.shiftKey = rawEvent.shiftKey;

  if (rawEvent.preventDefault) {
    e.preventDefault = function () {
      rawEvent.preventDefault();
    };
  }

  return e;
}

function typeToButtons(type) {
  var ret = 0;

  if (type === 'touchstart' || type === 'touchmove' || type === 'pointerdown' || type === 'pointermove') {
    ret = 1;
  }

  return ret;
}

var firstPointer = null;

function isPrimaryPointer(touch) {
  return firstPointer === touch.identifier;
}

function setPrimaryPointer(touch) {
  if (firstPointer === null) {
    firstPointer = touch.identifier;
  }
}

function removePrimaryPointer(touch) {
  if (firstPointer === touch.identifier) {
    firstPointer = null;
  }
}

function eventHandlerFactory(type) {
  return function (rawEvent) {
    var changedTouches = rawEvent.changedTouches;

    for (var i = 0; i < changedTouches.length; i++) {
      var touch = changedTouches[i];

      if (i === 0 && type === 'pointerdown') {
        setPrimaryPointer(touch);
      } else if (type === 'pointerup' || type === 'pointercancel') {
        removePrimaryPointer(touch);
      }

      var event = touchToPointer(type, touch, rawEvent);
      $document.dispatchEvent(event);
    }
  };
}

var dispatchPointerDown = eventHandlerFactory('pointerdown');
var dispatchPointerMove = eventHandlerFactory('pointermove');
var dispatchPointerUp = eventHandlerFactory('pointerup');
export { dispatchPointerDown, dispatchPointerMove, dispatchPointerUp };
//# sourceMappingURL=PointerEvent.js.map